var path = 'app/components/common/pageHeader/pageHeader.html';
var html = "<div small-header class=\"normalheader transition\"><div class=\"hpanel\"><div class=\"panel-body\"><a ng-click=\"small()\"><div class=\"clip-header\"><i class=\"fa fa-arrow-up\"></i></div></a><div class=\"pull-right\" compile=\"vm.icon\" compileOnce=\"true\"><breadcrumb></breadcrumb></div><h2 class=\"font-light m-b-xs\" compile=\"vm.pageTitle\" compileOnce=\"true\"></h2><small ng-bind-html=\"vm.pageDesc\"></small></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/pageHeader/pageHeader.html
// module id = 454
// module chunks = 0